import { Pagination, Table } from "antd";
import moment from "moment";

const SalesDataTable = (props) => {
  const columns = [
    {
      title: "DATE",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <div className="collection-table-item">
          {moment.utc(createdAt).format("DD-MM-YYYY")}
        </div>
      ),
      width: 100,
    },
    {
      title: "TIME",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (
        <div className="collection-table-item">
          {moment(createdAt).format("HH:mm:ss")}
        </div>
      ),
      width: 100,
    },
    {
      title: "BOX NO",
      dataIndex: "box_number",
      key: "box_number",
      render: (text,record) => <div>{record?.box_number}</div>,
    },
    {
      title: "RATE",
      dataIndex: "rate",
      key: "rate",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "WEIGHT",
      dataIndex: "chargable_weight",
      key: "chargable_weight",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "SERVICE",
      dataIndex: "",
      key: "",
      render: (text) => {
        return <div>{text?.service?.name}</div>;
      },
    },
    {
      title: "PACKING CHARGE",
      dataIndex: "packing_charge",
      key: "packing_charge",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "DUTY CHARGE",
      dataIndex: "duty",
      key: "duty",
      render: (text) => <div>{text}</div>,
    },
    {
      title: "TOTAL AMOUNT",
      dataIndex: "totalCharge",
      key: "totalCharge",
      render: (text) => <div>{Number(text).toFixed(1)}</div>,
      align: "center",
    },
    {
      title: "PAID",
      dataIndex: "totalPaid",
      key: "totalPaid",
      render: (text) => <div>{Number(text).toFixed(1)}</div>,
    },
    {
      title: "PAID BY CASH",
      dataIndex: "boxPaidCash",
      key: "boxPaidCash",
      render: (text) => <div>{Number(text).toFixed(1)}</div>,
    },
    {
      title: "PAID BY BANK",
      dataIndex: "boxPaidBank",
      key: "boxPaidBank",
      render: (text) => <div>{Number(text).toFixed(1)}</div>,
    },
    {
      title: "DISCOUNT",
      dataIndex: "totalDiscount",
      key: "totalDiscount",
      render: (text) => <div>{Number(text).toFixed(1)}</div>,
    },
    {
      title: "OUTSTANDING",
      dataIndex: "balance",
      key: "balance",
      render: (text) => (
        <span style={{ color: "red" }}>{Number(text).toFixed(1)}</span>
      ),
    },

    {
      title: "CREATED BY",
      dataIndex: "created_user",
      key: "created_user",
      render: (user) => <div>{user?.name}</div>,
    },
  ];

  const handlePaginationChange = (newPage, newPageSize) => {
    if (props.PageOnchange) {
      props.PageOnchange(newPage, newPageSize);
    }
  };

  return (
    <div>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={props?.data}
        size="small"
        rowKey={(record) => record?.box_number}
        pagination={false}
        scroll={{ x: true }}
      />
      <br />
      <div align="right">
        <Pagination
          responsive
          current={props?.meta?.page || 1}
          total={props?.meta?.itemCount || 0}
          pageSize={props?.meta?.take || 10}
          onChange={handlePaginationChange}
          showSizeChanger
        />
      </div>
    </div>
  );
};

export default SalesDataTable;
